import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AffiliateMarketingService } from '@api/affiliate-marketing.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-affiliate-marketing',
  templateUrl: './affiliate-marketing.component.html',
  styleUrls: ['./affiliate-marketing.component.scss']
})
export class AffiliateMarketingComponent implements OnInit {
  affiliateData;
  affiliateDataEnum;
  approveList;
  public destroy$ = new Subject<void>();
  approveListField;
  public affiliateForm: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private affiliateMarketingService: AffiliateMarketingService
  ) {
  }

  ngOnInit(): void {
    this.affiliateForm = this.formBuilder.group({
      refereeDiscount: [null, []],
      referrerDiscount: [null, []],
      directProfitlevel1_first: [null, []],
      directProfitlevel1_second: [null, []],
      directProfitlevel1_third: [null, []],
      inlineDirectProfitlevel1_first: [null, []],
      inlineDirectProfitlevel1_second: [null, []],
      inlineDirectProfitlevel1_third: [null, []],
      directProfitlevel2_first: [null, []],
      directProfitlevel2_second: [null, []],
      directProfitlevel2_third: [null, []],
      inlineDirectProfitlevel2_first: [null, []],
      inlineDirectProfitlevel2_second: [null, []],
      inlineDirectProfitlevel2_third: [null, []],
      Profitlevel1_first: [null, []],
      Profitlevel1_second: [null, []],
      Profitlevel1_third: [null, []],
      Profitlevel2_first: [null, []],
      Profitlevel2_second: [null, []],
      Profitlevel2_third: [null, []],
      providerRegistration: [null, []],
      providerPersonAuthorization: [null, []],
      providerCompanyAuthorization: [null, []],

    })

    this.affiliateMarketingService.getAffiliateSetting().subscribe((res) => {
      this.affiliateData = res?.affiliateSetting;
      this.affiliateDataEnum = res?.AffiliateProfitSettingEnum
      this.getAffiliateValue();
    });

  }
  getAffiliateValue() {
    this.affiliateForm.patchValue(this.affiliateData);
    for (let i = 0; i < this.affiliateData.length; i++) {
      if (this.affiliateData[i].id === this?.affiliateDataEnum?.refereeDiscount) {
        this.affiliateForm.get('refereeDiscount').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.referrerDiscount) {
        this.affiliateForm.get('referrerDiscount').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.directProfitlevel1_first) {
        this.affiliateForm.get('directProfitlevel1_first').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.directProfitlevel1_second) {
        this.affiliateForm.get('directProfitlevel1_second').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.directProfitlevel1_third) {
        this.affiliateForm.get('directProfitlevel1_third').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.inlineDirectProfitlevel1_first) {
        this.affiliateForm.get('inlineDirectProfitlevel1_first').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.inlineDirectProfitlevel1_second) {
        this.affiliateForm.get('inlineDirectProfitlevel1_second').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.inlineDirectProfitlevel1_third) {
        this.affiliateForm.get('inlineDirectProfitlevel1_third').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.directProfitlevel2_first) {
        this.affiliateForm.get('directProfitlevel2_first').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.directProfitlevel2_second) {
        this.affiliateForm.get('directProfitlevel2_second').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.directProfitlevel2_third) {
        this.affiliateForm.get('directProfitlevel2_third').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.inlineDirectProfitlevel2_first) {
        this.affiliateForm.get('inlineDirectProfitlevel2_first').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.inlineDirectProfitlevel2_second) {
        this.affiliateForm.get('inlineDirectProfitlevel2_second').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.inlineDirectProfitlevel2_third) {
        this.affiliateForm.get('inlineDirectProfitlevel2_third').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.Profitlevel1_first) {
        this.affiliateForm.get('Profitlevel1_first').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.Profitlevel1_second) {
        this.affiliateForm.get('Profitlevel1_second').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.Profitlevel1_third) {
        this.affiliateForm.get('Profitlevel1_third').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.Profitlevel2_first) {
        this.affiliateForm.get('Profitlevel2_first').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.Profitlevel2_second) {
        this.affiliateForm.get('Profitlevel2_second').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.Profitlevel2_third) {
        this.affiliateForm.get('Profitlevel2_third').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.providerRegistration) {
        this.affiliateForm.get('providerRegistration').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.providerPersonAuthorization) {
        this.affiliateForm.get('providerPersonAuthorization').patchValue(this.affiliateData[i]?.percent);
      }
      else if (this.affiliateData[i].id === this?.affiliateDataEnum?.providerCompanyAuthorization) {
        this.affiliateForm.get('providerCompanyAuthorization').patchValue(this.affiliateData[i]?.percent);
      }
    }

  }
  submit() {
    this.approveList = [];
    // tslint:disable-next-line:forin
    for (const field in this.affiliateForm.controls) {
      this.affiliateData?.forEach(element => {
        if (element.key === field) {
          this.approveList.push({ id: element.id, percent: (this.affiliateForm.controls[field].value).toString(), type: element.type });
        }
      });
    }
    this.affiliateMarketingService.postAffiliateSetting(this.approveList).pipe(takeUntil(this.destroy$)).subscribe((res) => {
    }
    );
  }
}
